import React, { useEffect } from "react";
import "./App.css";
import NewMain from "./components/newMain";
import CourseDetails from "./components/courseDetails";
import { Route, Routes } from "react-router-dom";
import EnrollForm from "./components/EnrollForm";
import Blogs from "./components/Blogs";
import Career from "./components/Career";
import Contactus from "./components/Contactus";
import Scholarship from "./components/Scholarship";
import Loans from "./components/ObsoleteComponents/Loans";
import { LinkedInCallback } from "react-linkedin-login-oauth2";
import GetInfo from "./components/getInfo";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import Handsonexperience from "./components/Handsonexperience";
import Interviewprepcvreview from "./components/Interviewprepcvreview";
import Getajob from "./components/Getajob";
import GetUserDetails from "./components/getUserDetails";
import Profilepage from "./components/profilepage";
import WebinarForm from "./components/WebinarForm";
import BookConsultation from "./components/bookConsultation";
import Webinars from "./components/Webinars";
import Downloadcertificate from "./components/downloadcertificate";
import Handsonform from "./components/handsonform";
import DoyenAccess from "./pages/doyenAccess";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import DoyenaccessDetails from "./components/doyenaccessdetails";
import Termsandconditions from "./components/Termsandconditions";
import Privatepolicy from "./components/Privacypolicy";
import DoyenaccessSuccess from "./components/doyenaccessSuccess";
import DoyenaccessCancel from "./components/DoyenaccessCancel";
import EnrollFormSuccess from "./components/EnrollFormSuccess";
import EnrollFormCancel from "./components/EnrollFormCancel";
import BlogDetails from "./components/BlogDetails";
import CompleteSocialLogins from "./components/auth/completeSocialLogins";
import NewEng from "./components/newEng";
import Design from "./components/newDesign";
import DataScience from "./components/dataScience";
import NoCode from "./components/noCOde";
import CyberSecurity from "./components/cyberSecurity";
import Marketing from "./components/marketing";
import ProductManagement from "./components/productManagement";
import VerifyCert from "./components/verify";
import { CourseProvider } from "./components/Contexts/CoursesContext";
import { ICourseDetails } from "./components/EnrollTypes";
import { IUserDetails } from "./components/EnrollTypes";
import { ICourseRegistration } from "./components/EnrollTypes";
import UserVerification from "./components/auth/userVerification";
import RefundPolicy from "./components/Refundpolicy";
import BookMeeting from "./components/BookMeeting";
import BlogDetailsSlug from "./components/BlogDetailsSlug";

function App() {
  const helmetContext = {};
 
  useEffect(() => {
    const fetch = async () => {
      GetToken();
    };
    fetch();
  }, []);

  return (
    <div className="App">
      <HelmetProvider context={helmetContext}>
        <React.Suspense>
          <CourseProvider>
            <Routes>
              <Route path="/" element={<NewMain />} />
              <Route
                path="/complete-social-logins"
                element={<CompleteSocialLogins />}
              />
              <Route path="/coursedetails/:slug" element={<CourseDetails />} />
              <Route path="enroll/:slug" element={<EnrollForm />} />
              <Route path="verify/:id" element={<VerifyCert />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/career" element={<Career />} />
              <Route path="/contactus" element={<Contactus />} />
              <Route path="/scholarship" element={<Scholarship />} />
              <Route path="/loans" element={<Loans />} />
              <Route path="/schoolofengineering" element={<NewEng />} />
              <Route path="/schoolofdesign" element={<Design />} />
              <Route path="/schoolofmarketing" element={<Marketing />} />
              <Route path="/nocode" element={<NoCode />} />
              <Route
                path="/schoolofcybersecurity"
                element={<CyberSecurity />}
              />
              <Route
                path="/useraction"
                element={<UserVerification />}
              />
              <Route path="/schoolofdata" element={<DataScience />} />
              <Route path="/schoolofproduct" element={<ProductManagement />} />
              <Route path="/linkedin" element={<LinkedInCallback />} />
              <Route path="/getinfo" element={<GetInfo />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route
                path="/handsonexperience"
                element={<Handsonexperience />}
              />
              <Route
                path="/interviewprepcvreview"
                element={<Interviewprepcvreview />}
              />
              <Route path="/getajob" element={<Getajob />} />
              <Route path="/getUserDetails" element={<GetUserDetails />} />
              <Route path="/profile" element={<Profilepage />} />
              <Route path="/register/:slug" element={<WebinarForm />} />
              <Route path="/consult" element={<BookMeeting />} />
              <Route path="/webinars" element={<Webinars />} />
              <Route
                path="/downloadcertificate/:ids"
                element={<Downloadcertificate />}
              />
              <Route path="/handsonform" element={<Handsonform />} />
              <Route path="/doyenaccess" element={<DoyenAccess />} />
              <Route
                path="/doyenaccessregistration/:ids"
                element={<DoyenaccessDetails />}
              />
              <Route
                path="/termsandconditions"
                element={<Termsandconditions />}
              />
              <Route path="/privacypolicy" element={<Privatepolicy />} />
              <Route
                path="/doyenaccesssuccess"
                element={<DoyenaccessSuccess />}
              />
              <Route
                path="/doyenaccesssuccess/:ids"
                element={<DoyenaccessSuccess />}
              />
              <Route
                path="/doyenaccesscancel"
                element={<DoyenaccessCancel />}
              />
              <Route
                path="/enrollformsuccess"
                element={<EnrollFormSuccess />}
              />
              <Route path="/enrollformcancel" element={<EnrollFormCancel />} />
              <Route path="/bookConsultation" element={<BookConsultation />} />
              {/* <Route path="/bookConsultation" element={<BookMeeting/>} /> */}
              <Route
                path="/enrollformsuccess/:ids"
                element={<EnrollFormSuccess />}
              />
              <Route path="/note/blog/:blogId" element={<BlogDetails />} />
              <Route path="/blog/:slug" element={<BlogDetailsSlug />} />
              <Route path="/refundpolicy" element={<RefundPolicy/>} />
            </Routes>
          </CourseProvider>
        </React.Suspense>
      </HelmetProvider>
    </div>
  );
}

export default App;
export const baseUrl = process.env.REACT_APP_BASEURL;
export const getUserCountry = async () => {
  const isLocalhost = window.location.hostname === "test.academy.doyenify.com" || window.location.hostname === "localhost" ;

  if (!isLocalhost) {
    const cachedData = localStorage.getItem("UserCountryDetails");
    const cachedTime = localStorage.getItem("UserCountryDetailsTime");

    if (cachedData && cachedTime) {
      const now = new Date().getTime();
      const cachedTimeDiff = now - parseInt(cachedTime, 10);
      const millisecondsInADay = 24 * 60 * 60 * 1000;
      if (cachedTimeDiff < millisecondsInADay) {
        return JSON.parse(cachedData);
      }
    }
  }
  const api_key = process.env.REACT_APP_IPDATA_APIKEY;
  const res = await axios.get(`https://api.ipdata.co?api-key=${api_key}`);
  const UserCountryDetails = {
    countryCode: res.data.country_code,
    continentCode: res.data.continent_code,
    countryName: res.data.country_name,
    response: res,
  };

  if (!isLocalhost) {
    localStorage.setItem(
      "UserCountryDetails",
      JSON.stringify(UserCountryDetails)
    );
    localStorage.setItem(
      "UserCountryDetailsTime",
      new Date().getTime().toString()
    );
  }
  return UserCountryDetails;
};

 const fetchPromoLaunchDates = async() => {
  const promoLaunchString = sessionStorage.getItem("PromoLaunchDates");
  const cachedTime = localStorage.getItem("PromoLaunchTime");
  const PromoLaunchDates = promoLaunchString ? await JSON.parse(promoLaunchString) : null;
  
  if (PromoLaunchDates && cachedTime) {
    const now = new Date().getTime();
    const cachedTimeDiff = now - parseInt(cachedTime, 10);
    const twoDays = 2 * 60 * 60 * 1000;
    if (cachedTimeDiff < twoDays) {
      return PromoLaunchDates;
    }
  }

  let BaseUrl = baseUrl || "";
  let idToken = await GetToken();
  const response = await axios.get(`${BaseUrl}/promolaunch/iDwv2x1bNYMXPqh4X5U6`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    }
  ).catch(()=>console.log("Could not fetch promo launch details"));
  
  localStorage.setItem("PromoLaunchDates",JSON.stringify(response?.data?.data));
  localStorage.setItem("PromoLaunchTime", new Date().getTime().toString()
  );
  return response?.data.data;
}

export const GetToken = async () => {
  const storedToken = localStorage.getItem("idToken");
  const tokenExpiration = localStorage.getItem("tokenExpiration");

  const currentTime = new Date().getTime();
  if (storedToken && tokenExpiration && currentTime < Number(tokenExpiration)) {
    return storedToken;
  }

  try {
    const response = await axios.post(
      "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
        process.env.REACT_APP_FIREBASEAPIKEY,
      {
        email: process.env.REACT_APP_EMAIL,
        password: process.env.REACT_APP_PASSWORD,
        returnSecureToken: true,
      }
    );

    const idToken = response?.data?.idToken;
    const expiresIn = response?.data?.expiresIn;

    const newExpirationTime = new Date().getTime() + expiresIn * 1000;
    localStorage.setItem("idToken", idToken);
    localStorage.setItem("tokenExpiration", newExpirationTime.toString());

    return idToken;
  } catch (error: any) {
    console.log(error.message);
  }
};

export const PopulateContext = async (
  contextName: string
): Promise<
  IUserDetails | IUserDetails[] | ICourseDetails[] | ICourseRegistration[] | any
> => {
  try {
    const idToken = await GetToken();
    let url = "";
    const UserId = localStorage.getItem("UserId");
    if (UserId && contextName === "User") {
      url = `${baseUrl}/registration/${UserId}`;
    } else if (contextName === "Users") {
      url = `${baseUrl}/registration`;
    } else if (UserId && contextName === "Enrollees") {
      url = `${baseUrl}/course-registration`;
    } else if (contextName === "Courses") {
      url = `${baseUrl}/courses`;
    } else {
      console.log("Could not get url");
    }

    if (url) {
      const response = await axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })
        .catch(() => {});

      if (response?.status === 200) {
        if (
          contextName === "Courses" ||
          contextName === "Enrollees" ||
          contextName === "Users"
        ) {
          return response?.data;
        }
        if (contextName === "User") {
          return response?.data?.data;
        }
      }
    }
  } catch (error) {
    console.log("Could not refetch or repopulate context");
  }
};
export const getDiscountPercentage = async () => {
  let promoActive = false;
  let timerActive = false;
  let promoImage = " ";
  let displayCohortStart = new Date();
  let displayCohortEnd = new Date();
  let IsSpecialPromo = false;
  let SpecialCourse = "";

  let promoLaunchDates = await fetchPromoLaunchDates();
  if(promoLaunchDates){
  const today = new Date();
  const promoStartDate = new Date(promoLaunchDates.PromoStartDate);
  const promoEndDate = new Date(promoLaunchDates.PromoEndDate);
  const timerStartDate = new Date(promoLaunchDates.CountDownStartDate);
  const timerEndDate = new Date(promoLaunchDates.CountDownEndDate);
  const isPromoActive = promoLaunchDates.IsPromoActive;
  const isTimerActive = promoLaunchDates.IsCountDownActive;
  const DisplayImage = promoLaunchDates.DisplayImage;
  IsSpecialPromo = promoLaunchDates.IsSpecialPromo;
  SpecialCourse = promoLaunchDates.SpecialCourse;

  if (today >= promoStartDate && today <= promoEndDate && isPromoActive) {
    promoActive = true;
    promoImage = DisplayImage;
  }
  if(today >= timerStartDate && today <= timerEndDate && isTimerActive){
    timerActive = true;
    displayCohortStart = timerStartDate;
    displayCohortEnd = timerEndDate;
  }
  }
  return {promoActive, timerActive, promoImage, displayCohortStart, displayCohortEnd, IsSpecialPromo, SpecialCourse};
}

export const checkIfInDecember = ()=>{
  let weAreInDecember = false;
  let date = new Date();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  if ((month === 12 && day >=1 && day <= 31)) {
    weAreInDecember = true;
  }
  return {weAreInDecember};
}